import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { FrontendApi, RegistrationFlow } from '@ory/client';
import { from, of as observableOf } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { State } from '../../reducers';

import { auth as authSelectors } from '../auth.selectors';
import * as actions from './registration.actions';

export interface KratosError {
  error: {
    id: string;
    code: number;
    status: string;
    reason: string;
    message: string;
  };
  redirect_browser_to?: string;
}

@Injectable()
export class AuthRegistrationEffects {
  beginRegistrationFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestBeginRegistrationFlow),
      withLatestFrom(this.store.select(authSelectors.getPostLoginRoute)),
      switchMap(([action, route]) =>
        from(
          this.kratos.createBrowserRegistrationFlow({
            afterVerificationReturnTo: route,
          })
        ).pipe(
          map((res) =>
            actions.SuccessBeginRegistrationFlow({
              flow: res.data,
            })
          ),
          catchError((err) => observableOf(actions.FailBeginRegistrationFlow({ error: err })))
        )
      )
    )
  );

  completeRegistrationFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestCompleteRegistrationFlow),
      withLatestFrom(this.store.select(authSelectors.getRegistrationFlow)),
      switchMap(([action, flow]) =>
        from(
          this.kratos
            .updateRegistrationFlow({
              flow: (<RegistrationFlow>flow).id,
              updateRegistrationFlowBody: action.payload,
            })
            // we need the error payloads, and they get stripped away if we just catch the
            // observable error
            .catch((err) => {
              return err.response;
            })
        ).pipe(
          map((res) => {
            if (res.status >= 200 && res.status < 400) {
              return actions.SuccessCompleteRegistrationFlow({ response: res.data });
            } else {
              return actions.FailCompleteRegistrationFlow({ response: res.data });
            }
          }),

          catchError((err) => {
            console.log(err);
            return observableOf(actions.FailCompleteRegistrationFlow({ response: err }));
          })
        )
      )
    )
  );

  constructor(
    private store: Store<State>,
    private actions$: Actions,
    private kratos: FrontendApi
  ) {}
}
